// extracted by mini-css-extract-plugin
export default {"selectContainer":"CustomSelector-module__selectContainer___EC5sZ","disabledMessage":"CustomSelector-module__disabledMessage___oKfka","label":"CustomSelector-module__label___Y8lT0"};